(function () {
    'use strict';
    angular.module('app').controller('TransitWarrantyRateSettingsModal', TransitWarrantyRateSettingsModal);
    TransitWarrantyRateSettingsModal.$inject = [
        'Carrier',
        '$rootScope',
        '$uibModalInstance',
        'details',
        'toastr',
        'TransitWarrantyService',
        'ClientService',
        '$scope'
    ];

    function TransitWarrantyRateSettingsModal(
        Carrier,
        $rootScope,
        $uibModalInstance,
        details,
        toastr,
        TransitWarrantyService,
        ClientService,
        $scope
    ) {
        const vm = this;
        vm.getCarrierProfiles = getCarrierProfiles;
        vm.searchForCompany = getAllCompany;
        vm.submit = submit;
        vm.closeModal = closeModal;
        vm.onSelect = onSelect;
        vm.onSelectCompany = onSelectCompany;
        vm.clearSelectedCompany =clearSelectedCompany;
        vm.clearSelectedcarrierProfiles =clearSelectedcarrierProfiles;
        vm.companies = [];


        vm.providers = []

        init();

        function init() {
            getInsuranceProvider();
            vm.currency = $rootScope.GlobalProfile.office.currency;
            vm.details = details ? details : { carrierProfiles: [], companies: [] };

            
            // if (vm.details.carrierProfiles.length < 1) {
               
            // }

            // if (vm.details.companies.length < 1) {
                
            // }

            vm.details.provider = vm.providers.find(res => res.name == 'Self-Insure');
            getCarrierProfiles();
            getAllCompany();
            setWatcherInsuranceProvider();
        }

        function getAllCompany(select) {
            if (isAllSelectedCompany()) {
                vm.companies = [];
                return;
            }
            vm.searching = true;
            ClientService.Company.getAll(data => {
                // vm.companies = data.content;
                vm.companies = validateSelected(data.content, vm.details.companies)
                vm.companies.unshift({ name: 'All' });
                vm.searching = false;
            }, err => {
                toastr.error('Error', err);
                vm.searching = false;
            }, { name: select, size: 500, sort: 'name,desc' });
        }

        function validateSelected(data, filter){
            const bIds = new Set(filter.map(x => x.companyName));
            const onlyInA = data.filter(x => !bIds.has(x.name));
            return onlyInA;
        }

        function getCarrierProfiles(searTerm = '') {
            if (isAllSelected()) {
                vm.carrierProfiles = [];
                return;
            }

            vm.searching = true;
            Carrier.getExternalCarrierProfiles(success => {
                vm.carrierProfiles = success.content;
                // vm.carrierProfiles = validateSelected(success.content, vm.details.carrierProfiles)
                vm.carrierProfiles.unshift({ name: 'All' });
                vm.searching = false;
            }, error => {
                toastr.error(error.message, 'Can\'t Fetch Carrier Profiles');
                vm.searching = false;
            }, { name: searTerm });
        }

        function getInsuranceProvider() {
            TransitWarrantyService.providers.getAll(
                res => {
                    vm.providers = res.filter(item => item.status === true)
                },
                err => {

                }
            )
        }

        function setWatcherInsuranceProvider() {
            $scope.$watch('vm.details.warrantyProvider', () => {
                if (!vm.details.warrantyProvider) {
                    return
                }
                if (vm.details.warrantyProvider.name === 'Freight Insure') {
                    vm.disbled = true;
                    return
                }
                vm.disbled = false;
            })

        }

        function onSelect() {
            if (isAllSelected()) {
                vm.details.carrierProfiles = vm.details.carrierProfiles.filter(prof => prof.name === 'All');
            }
        }

        function onSelectCompany() {
            if (isAllSelectedCompany()) {
                vm.details.companies = vm.details.companies.filter(prof => prof.name === 'All');
            }
        }

        function isAllSelected() {
            return vm.details.carrierProfiles.find(prof => prof.name === 'All');
        }

        function isAllSelectedCompany() {
            return vm.details.companies.find(prof => prof.name === 'All');
        }

        function clearSelectedCompany(){
            vm.details.companies =[]
        }

        function clearSelectedcarrierProfiles(){
            vm.details.carrierProfiles =[]
        }

        function submit(form) {
            form.$setSubmitted();
            if (form.$valid) {
                saveData();
            }
        }

        function saveData() {
            if (details) {
                updateData();
                return;
            }
            createData();
        }

        function updateData() {
            vm.savingData = true;
            const payload = TransitWarrantyService.Rates.generateCreateRatePayload(vm.details);
            TransitWarrantyService.Rates.update(success => {
                vm.savingData = false;
                $uibModalInstance.close(success);
                toastr.success('Transit Warranty Settings Updated', 'Success');
            }, error => {
                toastr.error(error.message, 'Error');
                vm.savingData = false;
            }, details.id, payload);
        }

        function createData() {
            vm.savingData = true;
            const payload = TransitWarrantyService.Rates.generateCreateRatePayload(vm.details);
            TransitWarrantyService.Rates.create(success => {
                vm.savingData = false;
                $uibModalInstance.close(success);
                toastr.success('Transit Warranty Settings Created', 'Success'); 
            }, error => {
                toastr.error(error.message, 'Error');
                vm.savingData = false;
            }, payload);
        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/transit-warranty/modal/TransitWarrantyRateSettingsModal.js